export const transformFeedbackProblemOptions = options => options.map(option => {
  const {
    id,
    body,
    allow_user_input
  } = option;
  return {
    id,
    body,
    hasMessageInput: allow_user_input
  };
});